module.exports = __webpack_public_path__ + "img/brushes-left_en.aa7d145.jpg";